/**
 * 计价方式列表页面路径
 */
export const PRICING_LIST_PAGE_PATH = '/pricing/list'

/**
 * 计价方式创建页面路径
 */
export const PRICING_CREATE_PAGE_PATH = '/pricing/create'

/**
 * 计价方式编辑页面路径
 */
export const PRICING_EDIT_PAGE_PATH = '/pricing/edit'

/**
 * 计价方式详情页面路径
 */
export const PRICING_DETAIL_PAGE_PATH = '/pricing/detail'
